/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2021-11-15 11:36:57
 * @LastEditors: likk
 * @LastEditTime: 2023-11-26 20:34:58
 */
import Vue from "vue";
import Vuex from "vuex";
import state from "./states";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import map from "./modules/map";
import intelligentVisual from "./modules/intelligentVisual";

import h5 from "./modules/h5";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    map,
    intelligentVisual,
    h5
  },
  state,
  getters,
  mutations,
  actions,
  plugins: [
    // createPersistedState({
    //   storage: window.sessionStorage,
    //   key: "transferOrder",
    //   reducer(val) {
    //     return {
    //       contractInfo: val.transferOrder.contractInfo,
    //       orderInfo: val.transferOrder.orderInfo,
    //       intelligentAgricultural: val.transferOrder.intelligentAgricultural,
    //     };
    //   },
    // }),
  ],
});

export default store;
